
function IfSamePathThenScrollToTop(e) {

  // console.log("window.location.hash;", window.location.hash)  
  // console.log("window.location.pathname", window.location.pathname)
  // console.log("e.currentTarget.pathname", e.currentTarget.pathname)
  // console.log("baseURI", e.target.baseURI);
  if (window.location.pathname === e.currentTarget.pathname ){
    window.scrollTo(0, 0);
  } else if(window.location.pathname !== e.currentTarget.pathname && window.location.hash !== '') {
    window.scrollTo(0, 0);
  }
     
    return null;
}

export default IfSamePathThenScrollToTop

